<template>
  <div>
    <div class="section-title">
      <img class="" src="../assets/images/partner-title.png" alt="" />
    </div>
    <div class="partner-box">
      <!-- <ul>
        <li
          v-for="(item, index) in types"
          class="hvrradialin"
          :key="index + 1"
          @click="num = index;acnum=0"
          :class="{ hvrradialout: num == index }"
        >
          {{ item.title }}
        </li>
      </ul> -->
      <div class="partner-box-bottom">
        <!-- <div
          class="animate__animated animate__fadeIn"
          v-for="(d, index) in listDetail"
          :key="index"
          v-show="num == index"
        >
          <swiper :options="newsSwiper" ref="mySwiper">
            <swiper-slide v-for="(item, index) in d.partnerlist" :key="index">
              <div
                class="partner-list"
                @click="acnum = index"
                :class="{ activelist: acnum == index }"
              >
                <img class="logo" :src="item.logo" alt="" />
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="partner-box-text"
            v-for="(list, index) in d.partnerlist"
            :key="index"
            v-show="acnum == index"
          >
            <h3>{{ list.title }}</h3>
            <div class="textcontent">{{ list.content }}</div>
          </div>
        </div> -->

        <div
          class="animate__animated animate__fadeIn"
          v-for="(d, index) in types"
          :key="index"
          v-show="num == index"
        >
          <swiper :options="newsSwiper" ref="mySwiper">
            <swiper-slide v-for="(item, index) in customers" :key="index">
              <div
                class="partner-list">
                <img class="logo" :src="item.Logo" alt="" style="height:100%;" />
              </div>
            </swiper-slide>
            
          </swiper>
          <div v-show="customers.length>12" class="swiper-button-prev swiper-button-prev-par" slot="button-prev"></div>
            <div v-show="customers.length>12" class="swiper-button-next swiper-button-next-par" slot="button-next"></div>
          <!-- <div
            class="partner-box-text"
            v-for="(list, index) in (d.id<=0?customers:customers.filter(m=>m.Type==d.id))"
            :key="index"
            v-show="acnum == index"
          >
            <h3>{{ list.Name }}</h3>
            <div class="textcontent" v-html="list.Content"></div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../api/common";
export default {
  data() {
    return {
      num: 0,
      acnum: 0,
      types: [
        { title: "全部", id: 0 },
        { title: "部委", id: 1 },
        { title: "协会", id: 2 },
        { title: "企业", id: 3 },
      ],
      customers:[],
      
      newsSwiper: {
        slidesPerView: 3,
        slidesPerColumn: 4,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
        navigation: {
          nextEl: '.swiper-button-next-par',
          prevEl: '.swiper-button-prev-par'
        }
      },
    };
  },
  methods: {
    getList: function () {
      this.axios({
        method: "get",
        url: "/api/Home/GetCustomers",
        params: {},
      }).then((res) => {
        this.customers = res.data.data
      });
    },
  },
  mounted: function () {
    // console.log("mounted");
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.swiper-container {
    height: 100%;
    width: 100%;
    padding: 30px 30px 0px 30px;
}
.partner-box-text{
  padding: 0 30px 30px 30px;
}

.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  height: 53px;
    width: 22px;
    top: 45%;
    right: 3px;
    background: url('../assets/images/right-icon.png') no-repeat;
    background-size: 100% 100%;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    height: 53px;
    width: 22px;
    top: 45%;
    left: 3px;
    background: url('../assets/images/left-icon.png') no-repeat;
    background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/partnerView.vue